import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=b57a72f6"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b57a72f6')) {
      api.createRecord('b57a72f6', component.options)
    } else {
      api.reload('b57a72f6', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=b57a72f6", function () {
      api.rerender('b57a72f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/Settings.vue"
export default component.exports